<mat-spinner [diameter]="30"></mat-spinner>
<span trans>{{ data.message }}</span>